

export const solo_shows = [
    {
        "name": "Framsýning",
        "description": "",
        "date": "03/10",
        "location": "Ungdómsdeildin í Eik. Torshavn, Faroe Islands",
        "type": ""
    },
    {
        "name": "MESS skrivstovan",
        "description": "",
        "date": "",
        "location": "Art Gallerie Listagluggin. Torshavn, Faroe Islands",
        "type": ""
    },
    {
        "name": "X-08",
        "description": "",
        "date": "First Friday - 11/08",
        "location": "The Epicenter. Las Vegas NV",
        "type": ""
    },
    {
        "name": "Recent Work",
        "description": "",
        "date": "01/30/08",
        "location": "The Stirling Club, Turnberry Place. Las Vegas, NV",
        "type": ""
    },
    {
        "name": "Figura… te",
        "description": "5 Solo exhibitions: Salvador Rodríguez, José J. Galindo, Patricia García, Luis Fernando Camacho y Sergio Quintor",
        "date": "01/04",
        "location": "Casa de Ensueños Art Gallery. Guadalajara",
        "type": ""
    },
    {
        "name": "Rasgos depresivos",
        "description": "",
        "date": "04/02",
        "location": "Café Epicúreos. Guadalajara",
        "type": ""
    }
]